import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

const ImstatTable: React.FC<SvgIconProps> = props => {
	return (
		<SvgIcon {...props}>
			<path fill="none" d="M0 0h24v24H0z" />
			<path d="M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z" />
		</SvgIcon>
	);
};

export default ImstatTable;



// WEBPACK FOOTER //
// ./src/icons/ImstatTable.tsx